export default class Agreement {
	constructor (init = {}) {
		this.id = init.hasOwnProperty('id') ? init.id : null
		this.url = init.hasOwnProperty('url') ? init.url : ''
		this.confirmed = init.hasOwnProperty('confirmed') ? init.confirmed : false
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/Agreement.js